export default __webpack_public_path__ + "static/media/report_navicon.d4dfd1b7.svg";